"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateQuestionnaireData = void 0;
const en_1 = require("@faker-js/faker/locale/en");
const tools_1 = require("../tools");
const question_1 = require("./question");
/**
 * Generates a random questionnaire with between 2 and 5 questions in addition to the questions passed in parameters
 * @param questions
 * @returns
 */
const generateQuestionnaireData = (qus, onListQuestions = false) => {
    let nbQuestion = en_1.faker.number.int({
        min: 2,
        max: 5,
    });
    let requiredQuestion = en_1.faker.number.int(nbQuestion);
    const questions = [];
    if (qus) {
        for (const qu of qus) {
            questions.push(qu);
        }
    }
    for (let i = 0; i < nbQuestion; i++) {
        questions.push((0, question_1.generateQuestionDataRandom)(requiredQuestion == i, false, undefined, onListQuestions));
    }
    let nbSmalaLists = en_1.faker.number.int(5);
    const smalaListIds = [];
    for (let i = 0; i < nbSmalaLists; i++) {
        smalaListIds.push((0, tools_1.IDSource)());
    }
    return { questions };
};
exports.generateQuestionnaireData = generateQuestionnaireData;
